module.exports = "pegasus/assets/circle-linkedin.gif";